import { WEB_VIDEO_STATUS } from '@studio/constants/content-destination';
import { REQUEST_STATUS } from '@studio/constants/status-code-constants';

const canShowWebPlayer = (axiosStatus: number, webVideoStatus: string): boolean => {
  if (
    (axiosStatus === REQUEST_STATUS.HTTP_FORBIDDEN || axiosStatus === REQUEST_STATUS.HTTP_NOT_FOUND) &&
    webVideoStatus !== WEB_VIDEO_STATUS.STOPPED &&
    webVideoStatus !== WEB_VIDEO_STATUS.ABORTED &&
    webVideoStatus !== WEB_VIDEO_STATUS.ERROR
  ) {
    return false;
  }
  return true;
};

export default canShowWebPlayer;
